import { type Signal } from '@angular/core'
import { injectQuery } from '@tanstack/angular-query-experimental'
import { injectCartoClient } from '../../ooh/services/carto.helper'
import {
  fetchCampaignDemographics,
  type CampaignDemographicsFilters,
} from '../services/campaigns-demographics.service'

export {
  type CampaignDemographicsRow,
  type CampaignDemographicsFilters,
} from '../services/campaigns-demographics.service'

export function injectCampaignDemographicsQuery(
  filters: Signal<CampaignDemographicsFilters>,
) {
  const cartoClient = injectCartoClient()

  return injectQuery(() => {
    const f = filters()
    return {
      queryKey: ['campaign-demographics', f],
      queryFn: async ({ signal }) => {
        return fetchCampaignDemographics(cartoClient, f, signal)
      },
      enabled: f.delivery_id > 0,
    }
  })
}
